<template>
	<div>
        
        <header class="lmy-header lmy-header-w">
            <i class="iconfont icon-yuyin" onclick="window.history.go(-1)"></i>
        	{{details.ScenicName}}
    	</header>
        <!-- <div class="lmy-reservation-head"> 
            <div :class="activeTag=='notice'?'head-item active':'head-item'" @click="scopeToPosition('notice')"><span>预定须知</span></div>
            <div :class="activeTag=='info'?'head-item active':'head-item'" @click="scopeToPosition('info')"><span>景区介绍</span></div>
        </div> -->
        <div class="lmy-hotel-detail">
            <ul class="filter-bar">
                <li :class="activeTag=='notice'?'active':'' " @click="scopeToPosition('notice')"><span>预定须知</span></li>
                <li :class="activeTag=='info'?'active':'' " @click="scopeToPosition('info')"><span>景区介绍</span></li>
            </ul>
        </div>
		<div class="lmy-reservation">

        <div class="lmy-reservation-content" ref="notice">
            <div class="content-title">预定须知</div>
            <div class="content-s-title">开放时间</div>
            <p v-for="item in details.ScenicInfos.ScenicOpenTimes" v-if="details.ScenicInfos.ScenicOpenTimes">{{item.Info}} </p>
       
            <div class="content-s-title">免票政策</div>
            <p>{{details.FreePolicy}}</p>
        
            <div class="content-s-title">优惠人群</div>
            <p>{{details.OfferCrowd}}</p>
          
            <div class="content-s-title">开具发票</div>
            <p> 如需开具发票，可直接通过公众号联系龙猫游客服。</p>
            <div class="content-s-title">入园须知</div>
            <p>{{details.Explanation}}</p>
            <div class="content-s-title">温馨提示</div>
            <p>1.  为了您人身、财产的安全，请您避免在公开场合暴露贵重物品及大量现金。上街时需时刻看管好首饰、相机等随身物品。</p>
            <p>2.  游泳、漂流、潜水、滑雪、滑冰、戏雪、热气球、跳伞、浮潜、摩托艇、滑翔伞、动力伞、攀岩等活动项目，均存在危险。参与前请根据自身条件，并充分参考当地相关部门及其它专业机构的相关公告和建议后量力而行。请您在预订前阅读驴妈妈为您整理各项高风险活动的 <label class="book-notice" @click="toBookNotice">《安全须知》</label></p>
        </div>

        
        <div class="lmy-reservation-content lmy-mgt" ref="info">
            <div class="content-title">景区介绍</div>
            <div >
                <p>{{details.Description}}</p>
            </div>
            <div v-for="item in details.ScenicInfos.PlayAttraction" v-if="details.ScenicInfos.PlayAttraction">
                <div class="content-s-title">
                    {{item.Name}}
                </div>
                <p>{{item.Info}}</p>
                <div class="lmyrc-pics">
                    <img :src="img.Url | replaceImgSrc(4)"  v-for="img in item.Images"/>
                </div>
            </div>
            <div  v-if="!details.ScenicInfos.PlayAttraction&&!details.Description">
                <div class="content-s-title">
                    暂无数据
                </div>
            </div>
        </div>
        <!-- <div class="lmy-reservation-btn" onclick="window.history.go(-1)">立即预定</div> -->
    </div>
	</div>
</template>
<script>
    export default{
        name:'ticket-view',
        data(){
            return{
                details:JSON.parse(this.dao.get('ticketDetails')),
                activeTag:this.$route.query.item||'notice'
            }
        },
        methods:{
            toBookNotice(){
                this.$router.push('/bookNotice');
            },
            scopeToPosition(name) {

                var infoTop=this.$refs['info'];
                var noticeTop=this.$refs['notice'];
                switch(name){
                    case 'info':
                    window.scrollTo(0, infoTop.offsetTop-89 ); 
                    this.activeTag='info';
                    break;
                    case 'notice':
                    window.scrollTo(0,noticeTop.offsetTop-89 ); 
                    this.activeTag='notice';

                    break;
                }
                if(typeof name !='string' && this.$refs['info']){
                    var windowSrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop;
                    if(windowSrollTop+176>=infoTop.offsetTop){
                        this.activeTag='info';
                    }else{
                        this.activeTag='notice';
                    }

                }

            },
        },
        mounted(){
            this.scopeToPosition(this.activeTag)
            if(this.$refs['info']){
            // window.addEventListener('touchstart', this.scopeToPosition);
            window.addEventListener('touchmove',this.scopeToPosition);
            // window.addEventListener('touchend',this.scopeToPosition);
            window.addEventListener('scroll', this.scopeToPosition)
            }
        },
        // destroyed () {
        //     window.removeEventListener('scroll', this.handleScroll);
        // }
    }
</script>


// WEBPACK FOOTER //
// src/components/ticket/view.vue